import React from 'react';
import styled from 'styled-components';
import { OrderCleansingDto } from 'services/data-contracts';
import { useTranslation } from 'react-i18next';
type OrderStatus = OrderCleansingDto['status'];

interface StatusIndicatorProps {
  status: OrderStatus;
}

const StatusIndicator = ({ status }: StatusIndicatorProps) => {
  const { t } = useTranslation();
  const getStatusText = (status: OrderStatus) => {
    switch (status) {
      case 'RECEIVED':
        return t('Preparing');
      case 'PROCESSING':
        return t('Processing');
      case 'CLEANSED':
        return t('Validation Pending');
      case 'COMPLETED':
        return t('Completed');
      case 'VALIDATION_ERROR':
        return t('Validation Error');
      case 'USER_VERIFIED':
        return t('Verified');
      case 'TRANSMISSION_FAILED':
        return t('Transmission Failed');
      default:
        return status;
    }
  };

  return <StatusBadge status={status}>{getStatusText(status)}</StatusBadge>;
};

const StatusBadge = styled.div<{ status: OrderStatus }>`
  padding: 0.25rem 0.5rem;
  border-radius: 9999px;
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;

  ${({ status }) => {
    switch (status) {
      case 'RECEIVED':
        return `
          background-color: #fef9c3;
          color: #854d0e;
        `;
      case 'PROCESSING':
        return `
          background-color: #dbeafe;
          color: #1e40af;
        `;
      case 'CLEANSED':
        return `
          background-color: #F8E300;
          color: #2b2b2b;
        `;
      case 'USER_VERIFIED':
        return `
          background-color: #006781;
          color: #fff;
        `;
      case 'COMPLETED':
        return `
          background-color: #00A1F8;
          color: #fff;
        `;
      case 'VALIDATION_ERROR':
        return `
          background-color: #fee2e2;
          color: #991b1b;
        `;
      case 'TRANSMISSION_FAILED':
        return `
          background-color: #242424;
          color: #f0f0f0;
        `;
      default:
        return `
          background-color: #f3f4f6;
          color: #1f2937;
        `;
    }
  }}
`;

export default StatusIndicator;
